import * as models from 'smg/admin/models';
import axios from 'smg/axios';

// ChargeOrderPayment charges a single payment source against an order via
// POST /v2/order-payments and resolves with the structured result. A soft
// decline — card rejected by the issuer, insufficient account balance — comes
// back as `declined: true` on an HTTP 200, NOT a rejection: the request was
// valid and the system did exactly what was asked. Callers branch on
// `.declined` and only hit `.catch` for hard failures (network, validation,
// missing order).
//
// The request embeds an OrderPayment: it carries the order being paid
// (orderID), the charge amount (total; zero means the order's full remaining
// balance), and the payment source — either a saved `paymentOptionID` or an
// inline `paymentOption` sub-model the server creates first (the same
// bidirectional shape the order-create endpoint uses for shipping options).
// `poUploadIDs` ride alongside for PO-type charges.
//
// `idempotencyKey` identifies one intended charge attempt and MUST be reused
// across retries of that attempt — the server replays the recorded result for
// a key whose charge already committed, so a retry after a lost/timed-out
// response cannot double-charge (#5656).
export async function ChargeOrderPayment(
    orderPaymentInit: models.IOrderPayment,
    poUploadIDs?: number[],
    idempotencyKey?: string,
): Promise<models.OrderPaymentCreateResponse> {
    const body: Record<string, unknown> = { ...new models.OrderPayment(orderPaymentInit).toJSON() };
    if (poUploadIDs?.length) {
        body['poUploadIDs'] = poUploadIDs;
    }
    if (idempotencyKey) {
        body['idempotencyKey'] = idempotencyKey;
    }
    return axios.post('/v2/order-payments', body).then(r => models.OrderPaymentCreateResponse.fromJSON(r.data));
}
